import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowDown, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';

const HeroBackgroundTest = () => {
  const meditationPhoto = "https://customer-assets.emergentagent.com/job_light-school-1/artifacts/bj71myy7_Gemini_Generated_Image_cw5imecw5imecw5i.png";

  return (
    <div className="pt-20 bg-gray-100 min-h-screen">
      {/* Header */}
      <div className="bg-gray-900 text-white py-6 px-6 text-center">
        <h1 className="text-2xl font-bold">Hero con fondo de meditación</h1>
        <p className="text-gray-300 mt-2">Opciones de overlay y posición</p>
      </div>

      {/* OPCIÓN 1: Overlay suave crema */}
      <div className="py-8 px-4">
        <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
          OPCIÓN 1: Overlay crema suave (mantiene calidez)
        </h2>
        <div className="max-w-6xl mx-auto">
          <section className="relative min-h-[550px] rounded-2xl overflow-hidden shadow-xl">
            {/* Background image */}
            <div className="absolute inset-0">
              <img 
                src={meditationPhoto}
                alt="Meditación"
                className="w-full h-full object-cover"
              />
              {/* Cream overlay */}
              <div className="absolute inset-0 bg-[#faf8f5]/85" />
            </div>
            
            {/* Content */}
            <div className="relative h-full min-h-[550px] flex items-center justify-center">
              <div className="max-w-3xl px-6 text-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 text-[#c9a227] rounded-full text-sm font-medium mb-8">
                  <Sparkles className="w-4 h-4" />
                  Escuela de Consciencia Akáshica
                </div>
                
                <h1 className="text-5xl lg:text-6xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
                  Un espacio para
                  <span className="block text-[#c9a227]">volver a ti</span>
                </h1>
                
                <p className="text-xl text-gray-600 max-w-xl mx-auto mb-10">
                  Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full">
                    Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                  </Button>
                  <Button variant="outline" className="border-[#c9a227] text-[#c9a227] px-8 py-6 text-base rounded-full">
                    Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* OPCIÓN 2: Overlay más transparente */}
      <div className="py-8 px-4 bg-white">
        <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
          OPCIÓN 2: Overlay más transparente (se ve más la foto)
        </h2>
        <div className="max-w-6xl mx-auto">
          <section className="relative min-h-[550px] rounded-2xl overflow-hidden shadow-xl">
            {/* Background image */}
            <div className="absolute inset-0">
              <img 
                src={meditationPhoto}
                alt="Meditación"
                className="w-full h-full object-cover"
              />
              {/* Lighter overlay */}
              <div className="absolute inset-0 bg-[#faf8f5]/70" />
            </div>
            
            {/* Content */}
            <div className="relative h-full min-h-[550px] flex items-center justify-center">
              <div className="max-w-3xl px-6 text-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 text-[#c9a227] rounded-full text-sm font-medium mb-8">
                  <Sparkles className="w-4 h-4" />
                  Escuela de Consciencia Akáshica
                </div>
                
                <h1 className="text-5xl lg:text-6xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
                  Un espacio para
                  <span className="block text-[#c9a227]">volver a ti</span>
                </h1>
                
                <p className="text-xl text-gray-700 max-w-xl mx-auto mb-10">
                  Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                    Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                  </Button>
                  <Button variant="outline" className="border-[#c9a227] text-[#c9a227] bg-white/50 px-8 py-6 text-base rounded-full">
                    Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* OPCIÓN 3: Gradiente radial desde centro */}
      <div className="py-8 px-4 bg-gray-100">
        <h2 className="text-xl font-bold text-center mb-4 text-[#c9a227]">
          OPCIÓN 3: Gradiente radial (texto claro en centro, foto visible en bordes)
        </h2>
        <div className="max-w-6xl mx-auto">
          <section className="relative min-h-[550px] rounded-2xl overflow-hidden shadow-xl">
            {/* Background image */}
            <div className="absolute inset-0">
              <img 
                src={meditationPhoto}
                alt="Meditación"
                className="w-full h-full object-cover"
              />
              {/* Radial gradient overlay */}
              <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at center, rgba(250,248,245,0.95) 0%, rgba(250,248,245,0.7) 50%, rgba(250,248,245,0.4) 100%)' }} />
            </div>
            
            {/* Content */}
            <div className="relative h-full min-h-[550px] flex items-center justify-center">
              <div className="max-w-3xl px-6 text-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 text-[#c9a227] rounded-full text-sm font-medium mb-8 backdrop-blur-sm">
                  <Sparkles className="w-4 h-4" />
                  Escuela de Consciencia Akáshica
                </div>
                
                <h1 className="text-5xl lg:text-6xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
                  Un espacio para
                  <span className="block text-[#c9a227]">volver a ti</span>
                </h1>
                
                <p className="text-xl text-gray-600 max-w-xl mx-auto mb-10">
                  Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                    Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                  </Button>
                  <Button variant="outline" className="border-[#c9a227] text-[#c9a227] bg-white/50 px-8 py-6 text-base rounded-full">
                    Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Instructions */}
      <div className="py-8 bg-gray-900 text-white text-center">
        <h2 className="text-xl font-bold mb-4">¿Cuál te gusta más?</h2>
        <ul className="space-y-2 text-gray-300">
          <li>• <strong>Opción 1:</strong> Overlay crema 85% - Foto sutil de fondo</li>
          <li>• <strong>Opción 2:</strong> Overlay crema 70% - Foto más visible</li>
          <li>• <strong>Opción 3:</strong> Gradiente radial - Foto visible en los bordes</li>
        </ul>
      </div>
    </div>
  );
};

export default HeroBackgroundTest;
